import { environment } from '@environments/environment';

export const GET_FINITIONS_FURNITURES_QUERY = (langcode: string) => ({
  query: '_search',
  index: environment.integrations?.fournierWebservice?.index_finitions ?? '',
  body: {
    size: 10000,
    query: {
      bool: {
        filter: [
          {
            term: {
              search_api_datasource: 'entity:taxonomy_term',
            },
          },
          {
            term: {
              vid: 'type_de_meubles',
            },
          },
          {
            term: {
              search_api_language: langcode,
            },
          },
        ],
      },
    },
    sort: [
      {
        weight: 'asc',
      },
    ],
    _source: ['name', 'field_visuel', 'field_page_link'],
  },
});
